// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"3d3ed636","6795":"ebcf8d75","9305":"5b9113ec"}[chunkId] + ".chunk.css";
};